<template>
    <div id="gl_account_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="glAccountHeader" v-if="$route.params.id > 0">Update GL Account</span>
                    <span class="page-title" id="glAccountHeader" v-else>Add GL Account</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackGLAccountsList">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="glAccountForm">
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="location_id">Location:</label>
                                        <v-select v-model="location_id" name="location_id" placeholder="Select Location."
                                                label="text"
                                                :options="locationArr" id="location_id" @input="onLocationSelect($event)">
                                        </v-select>
                                        <div class="field-error">{{location_error_msg}}</div>                                                
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="account_type">Account Type:</label>
                                        <v-select v-model="account_type" name="account_type" placeholder="Select Account Type."
                                                label="text"
                                                :options="accountTypesArr" id="account_type" @input="onAccountTypeSelect($event)">
                                        </v-select>
                                        <div class="field-error">{{account_type_error_msg}}</div>                                                
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Code:</label>
                                        <div class="form-row">    
                                            <div class="col-sm-2 form-group">
                                                <input type="text" v-model="glCodeField1" id="glCodeField1" name="glCodeField1" class="form-control" placeholder="" @keypress="isNumberKey($event)" :disabled="locationPartDisable"/>
                                            </div>
                                            <div class="col-sm-3 form-group">
                                                <input type="text" v-model="glCodeField2" id="glCodeField2" name="glCodeField2" class="form-control" placeholder="" @keypress="isNumberKey($event)" @input="onAccountTypeFieldInput($event)" maxlength="4"/>
                                            </div>
                                            <div class="col-sm-2 form-group">
                                                <input type="text" v-model="glCodeField3" id="glCodeField3" name="glCodeField3" class="form-control" placeholder="" @keypress="isNumberKey($event)" maxlength="2"/>
                                            </div>
                                            <div class="col-sm-2 form-group">
                                                <input type="text" v-model="glCodeField4" id="glCodeField4" name="glCodeField4" class="form-control" placeholder="" @keypress="isNumberKey($event)" maxlength="2"/>
                                            </div>
                                        </div>
                                        <div class="field-error">{{code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="description">Description:</label>
                                        <input type="text" class="form-control" v-model="description" id="description" placeholder="Enter Description" name="description">
                                        <div class="field-error">{{description_error_msg}}</div>
                                    </div>
                                    <div class="field-error">{{common_error_msg}}</div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateGLAccountBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateGLAccount" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateGLAccountBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateGLAccount" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueGLAccountBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateGLAccount(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelGLAccountBtn" class="btn btn-tertiary" v-on:click.prevent="BackGLAccountsList">
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';
export default {
  name: "GLAccountCreate",
  metaInfo() {
    return {
        title: (this.$route.params.id > 0)? "Update GL Account | " +process.env.COPYRIGHT_NAME : "Create GL Account | " +process.env.COPYRIGHT_NAME
    }
  },
  
  mixins:[commonMixins,contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    description: "",
    account_type:"",
    accountTypesArr:[],
    loading:false,
    code_error_msg: "",
    description_error_msg:"",
    common_error_msg:"",
    location_id:"",
    company:"",
    locationArr:[],
    account_type_error_msg:"",
    location_error_msg:"",
    glCodeField1:"",
    glCodeField2:"",
    glCodeField3:"",
    glCodeField4:"",
    locationPartDisable:false    
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_gl_account') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['accountTypes','location']);

        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");
            
            if (segments[3]) {
                self.loadGLAccount();
            }
        }, 100);
  },
  methods: {
    BackGLAccountsList() {
      var self = this;
      self.$router.push("/gl-account/list");
    },

    CreateGLAccount(flag) {
      var self = this;
      var error = false;      
      self.code_error_msg = "";
      self.description_error_msg = "";
      self.common_error_msg = "";
      self.account_type_error_msg = "";
      self.location_error_msg = "";

      if (!self.description || self.description == null || self.description == "") {
        self.description_error_msg = "Description Required.";
        error = true;
      }

      if (!self.account_type || self.account_type == null || self.account_type == "") {
        self.account_type_error_msg = "Account Type Required.";
        error = true;
      }

      if (!self.location_id || self.location_id == null || self.location_id == "") {
        self.location_error_msg = "Location Required.";
        error = true;
      }

      if (!self.glCodeField1 || self.glCodeField1 == null || self.glCodeField1 == "") {
        self.code_error_msg = "Code Required.";
        error = true;
        return;
      }

      if (!self.glCodeField2 || self.glCodeField2 == null || self.glCodeField2 == "") {
        self.code_error_msg = "Account Type Code Required.";
        error = true;
        return;
      }

      if (self.glCodeField2 != null && self.glCodeField2 != "") {
          
        if (self.glCodeField2 && self.glCodeField2.length < 4) {
            self.code_error_msg = "Account Type Code should be of 4 characters.";
            error = true;
            return;   
        }

        if (self.account_type != null) {
            var startNo = Number(self.account_type.from_no);
            var toNo = Number(self.account_type.to_no);

            if ( (Number(self.glCodeField2) < startNo) || (Number(self.glCodeField2) > toNo)) {
                self.code_error_msg = "Account Type Code should be in proper range.";
                error = true;
                return;
            }
        }
      }

      if (!self.glCodeField3 || self.glCodeField3 == null || self.glCodeField3 == "") {
        self.code_error_msg = "Sequence Required.";
        error = true;
        return;
      }

      if (self.glCodeField3 != null && self.glCodeField3 != "") {

        if (self.glCodeField3 && self.glCodeField3.length < 2) {
            self.code_error_msg = "Sequence should be of 2 characters.";
            error = true;
            return;   
        }    
      }

      if (!self.glCodeField4 || self.glCodeField4 == null || self.glCodeField4 == "") {
        self.code_error_msg = "Sequence Required.";
        error = true;
        return;
      }

      if (self.glCodeField4 != null && self.glCodeField4 != "") {

        if (self.glCodeField4 && self.glCodeField4.length < 2) {
            self.code_error_msg = "Sequence should be of 2 characters.";
            error = true;
            return;   
        }    
      }
      
      if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateGLAccountBtn").val("Updating ...");
                $("#CreateGLAccountBtn").prop("disabled", true);
                $("#cancelGLAccountBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueGLAccountBtn").val("Saving ...");
                    $("#CreateGLAccountBtn").prop("disabled", true);
                    $("#createAndContinueGLAccountBtn").prop("disabled", true);
                    $("#cancelGLAccountBtn").prop("disabled",true);

                }else{

                    $("#CreateGLAccountBtn").val("Saving ...");
                    $("#CreateGLAccountBtn").prop("disabled", true);
                    $("#createAndContinueGLAccountBtn").prop("disabled", true);
                    $("#cancelGLAccountBtn").prop("disabled",true);
                }
               
            }
            
            var fields = $("#glAccountForm").serializeArray();
            if ( !self.account_type || self.account_type.value == "" ) {
                fields.push({name: "account_type", value: ""});
            }else{
                fields.push({name: "account_type", value: self.account_type.value});
            }
            if ( !self.location_id || self.location_id.value == "" ) {
                fields.push({name: "location_id", value: ""});
            }else{
                fields.push({name: "location_id", value: self.location_id.value});
            }
            fields.push({name: "code", value: self.getFormattedGLCode()});
            fields.push({name: "id", value: segments[3]});

            $.ajax({
                url: process.env.ROOT_API + "/gl-account/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateGLAccountBtn").val("Update");
                        $("#CreateGLAccountBtn").prop("disabled", false);
                        $("#cancelGLAccountBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueGLAccountBtn").val("Save and Continue");
                            $("#CreateGLAccountBtn").prop("disabled", false);
                            $("#createAndContinueGLAccountBtn").prop("disabled", false);
                            $("#cancelGLAccountBtn").prop("disabled",false);

                        }else{

                            $("#CreateGLAccountBtn").val("Save");
                            $("#CreateGLAccountBtn").prop("disabled", false);
                            $("#createAndContinueGLAccountBtn").prop("disabled", false);
                            $("#cancelGLAccountBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#glAccountForm").trigger("reset");
                            self.description ="";
                            self.account_type = "";
                            self.location_id = "";
                            self.glCodeField1 = "";
                            self.glCodeField2 = "";
                            self.glCodeField3 = "";
                            self.glCodeField4 = "";
                            self.loadFieldData(['accountTypes']);                            
                    
                        }else{
                            self.$router.push("/gl-account/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                                self.common_error_msg += data.content[i] + "\n";
                            }
                            // $("#errorMsg").html(err);
                            // $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                // $(".alert-warning").removeClass("show");
                                // $(".alert-warning").addClass("hide");
                                self.common_error_msg = "";
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateGLAccountBtn").val("Update");
                        $("#CreateGLAccountBtn").prop("disabled", false);
                        $("#cancelGLAccountBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#glAccountForm").trigger("reset");
                            

                            $("#createAndContinueGLAccountBtn").val("Save and Continue");
                            $("#CreateGLAccountBtn").prop("disabled", false);
                            $("#createAndContinueGLAccountBtn").prop("disabled", false);
                            $("#cancelGLAccountBtn").prop("disabled",false);

                        }else{

                            $("#CreateGLAccountBtn").val("Save");
                            $("#CreateGLAccountBtn").prop("disabled", false);
                            $("#createAndContinueGLAccountBtn").prop("disabled", false);
                            $("#cancelGLAccountBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,false,'glaccount-create');
                }
            });
      }else{
            self.errorValidationFocus();
      }
    },

    loadGLAccount() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/gl-account/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                
                if (data.status == "success") {
                    self.description = self.ucString(data.content.description);
                    if (data.content.account_type_desc != null && data.content.account_type_desc != "") {
                        self.account_type = {value:data.content.account_type_id,text:data.content.account_type_code + " | " + self.ucString(data.content.account_type_desc)};
                    }
                    self.company = data.content.company;
                    if (data.content.locName != null && data.content.locName != "") {
                        self.location_id = {value:data.content.location_id,text:self.ucString(data.content.locName) + " | " + data.content.locCode};
                    }
                    //gl code format array
                    if (data.content.codeArr.length > 0) {
                        self.glCodeField1 = data.content.codeArr[0];
                        self.glCodeField2 = data.content.codeArr[1];
                        self.glCodeField3 = data.content.codeArr[2];
                        self.glCodeField4 = data.content.codeArr[3];
                        self.locationPartDisable = true;
                    }
                                      
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'glaccount-details');
            }
        });
    },
    isNumberKey: function(evt) { 

        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();            
        } else {
            return true;
        }
    },
    onLocationSelect(evt) {
        var self = this;
        self.location_error_msg = "";
        if (self.location_id != null) {
            var code = self.location_id.text.split('|');
            self.glCodeField1 = code[0].trim();
            self.locationPartDisable = true;
        }else{
            self.locationPartDisable = true;
            self.glCodeField1 = "";
        }
    },
    onAccountTypeSelect(evt) {
        var self = this;
        self.account_type_error_msg = "";
        self.glCodeField2 = "";
    },
    onAccountTypeFieldInput() {
        var self = this;
        self.account_type_error_msg = "";
        if (!self.account_type || self.account_type == null || self.account_type == "") {
            self.account_type_error_msg = "Account Type Required.";
            self.glCodeField2 = "";
        }
    },
    getFormattedGLCode(){
        var self = this;
        var code = "";
        if(self.glCodeField1 != "" && self.glCodeField2 != "" && self.glCodeField3 != "" && self.glCodeField4){
            code = self.glCodeField1.trim() + self.glCodeField2.trim() + self.glCodeField3.trim() + self.glCodeField4.trim();
            return code;     
        }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/accounting/GLAccountCreate.vue